<template>
  <div id="app" class="fs-14" :class="[{'app-page--has-topbar': hasTopbar},{'swan-compatible':libPlatform.isBaiduminiapp}]">
    <top-bar v-if="hasTopbar&&!libPlatform.isBaiduminiapp" ref="topBar"/>
    <router-view class="app-page__inner"/>
  </div>
</template>

<script>
import APIS from '@/util/apis'
import topBar from '@/components/top-bar'
import channelIdMap from '@/util/channelIdMap.config'
import {getPlatform} from "./frontend-lib/tools/getPlatform";
import PageGrayFilter from './frontend-lib/component/PageGrayFilter/index'

export default {
  name: 'App',
    data(){
      return {
          libPlatform:getPlatform()
      }
    },
  components: {
    topBar
  },
  computed: {
    hasTopbar () {
      return this.$store.state.topbarConfig.show
    }
  },
  // 页面首屏需要异步获取数据
  asyncData ({store, route}) {
    const { isWebviewMp, isAliPay, isMei} = route.query
    let channelId = route.query.channelId
    if (isWebviewMp == 1 && isAliPay == 1) {
      channelId = 4925
    } else if (/miniProgram MMP/i.test(navigator.userAgent)) {
      channelId = 5292
    }
    store.commit('setChannelId', channelId)
    return store.dispatch('getUserInfo', {token: route.query.token}).then((platformData) => {
      if ((platformData.data.user instanceof Array) && !route.query.userId) {
        if (route.query.userKey) {
          console.info('---平台登录信息为空，但是URL带有userKey---')
          store.commit('userInfo', {
            userId: route.query.userId,
            userKey: route.query.userKey
          })
          return Promise.resolve()
        } else {
          console.info('---平台登录信息为空，下面的获取测评userKey不用走了---')
          return Promise.resolve()
        }
      }
      console.info('---平台登录信息不为空，请求userKey刷新---')
      return store.dispatch('getUserKey', Object.assign({
        userId: platformData.data.user.id || route.query.userId,
        unionId: platformData.data.user.wx_unionid || route.query.unionId,
        avatar: platformData.data.user.avatar,
        nickname: platformData.data.user.nickname
      }, {channelId: store.state.channelId}))
    }).then(res => {
      console.info('---刷新vipinfo---')
      return store.dispatch('fetchVipinfo', Object.assign({
        userKey: route.query.userKey || store.state.userInfo.userKey
      }, {channelId: store.state.channelId }))
    })
  },
  created () {
    if (this.platform.isPc && !this.$route.meta.allowPC) {
      this.$toast('即将跳转到PC页面')
      setTimeout(() => {
        location.replace(`http://www${APIS.env}.xinli001.com/ceshi?source=pc-home`)
      }, 2000)
    }
  },
  mounted () {
    // document.addEventListener('gesturestart', function (event) {
    //     event.preventDefault();
    // });
    // 禁用双指缩放：
    document.documentElement.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    }, false)
    // 禁用手指双击缩放：
    var lastTouchEnd = 0
    document.documentElement.addEventListener('touchend', function (event) {
      var now = Date.now()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    }, false)

    this.$tracker.setGlobalParams({
      '渠道ID': this.contextData.channelId,
      '渠道': channelIdMap.map[this.contextData.channelId]
    })

    PageGrayFilter()
  },
  methods:{
  }
}
</script>

<!-- <style src="swiper/dist/css/swiper.css"></style> -->
<style src="./scss/swiper.css"></style>
<style src="./scss/common.scss" lang="scss"></style>
<style>
    .swan-compatible .app-page__inner{
        margin-top: -40px;
    }
    .swan-compatible .result-card-action,
    .swan-compatible .fun-result-recommend{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue